import React from "react";
import { BRAND, CONTACTS } from "../data/content";

const Footer = () => {
  const year = new Date().getFullYear();
  return (
    <footer className="bg-burgundy-ink text-cream/85 pt-16 pb-10 border-t border-burgundy" data-testid="site-footer">
      <div className="container-x grid grid-cols-1 md:grid-cols-12 gap-10">
        <div className="md:col-span-5">
          <div className="font-heading text-5xl text-cream leading-none">{BRAND.name}</div>
          <p className="mt-3 text-sm uppercase tracking-[0.22em] text-cream/60">{BRAND.tagline}</p>
          <p className="mt-6 text-cream/75 max-w-md">{BRAND.description}</p>
        </div>

        <div className="md:col-span-3">
          <p className="text-xs uppercase tracking-[0.22em] text-cream/60">Контакты</p>
          <ul className="mt-4 space-y-2 text-sm">
            <li><a href={`tel:${CONTACTS.phoneRaw}`} className="hover:text-gold transition-colors">{CONTACTS.phone}</a></li>
            <li><a href={`mailto:${CONTACTS.email}`} className="hover:text-gold transition-colors break-all">{CONTACTS.email}</a></li>
            <li className="text-cream/70">{CONTACTS.address}</li>
          </ul>
        </div>

        <div className="md:col-span-4">
          <p className="text-xs uppercase tracking-[0.22em] text-cream/60">Соцсети</p>
          <ul className="mt-4 flex gap-3">
            {CONTACTS.socials.map((s) => (
              <li key={s.label}>
                <a href={s.url} className="px-4 py-2 border border-cream/40 hover:bg-cream hover:text-burgundy transition-colors text-xs uppercase tracking-[0.18em] inline-block" data-testid={`footer-social-${s.label.toLowerCase()}`}>
                  {s.label}
                </a>
              </li>
            ))}
          </ul>
        </div>
      </div>

      <div className="container-x mt-14 pt-6 border-t border-cream/15 flex flex-col md:flex-row justify-between gap-4 text-xs text-cream/50 uppercase tracking-[0.22em]">
        <span>© {year} Мастерская «Щётка». {BRAND.slogan}.</span>
        <span>Сделано с любовью к ремеслу</span>
      </div>
    </footer>
  );
};

export default Footer;
